import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  section: css`
    overflow: visible !important;
  `,

  header: css`
    background-color: transparent;
    padding-inline: 16px;
    padding-block-start: 20px;
    padding-block-end: 0;
    min-block-size: 60px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,

  validator: css`
    padding-block-start: 8px;
    inline-size: 100%;
    margin-inline: -16px;
  `,

  content: css`
    padding-inline: 16px;
    padding-block-start: 16px;
    padding-block-end: 8px;
  `,

  footer: css`
    display: flex;
    gap: 4px;
    padding-block: 8px;
    padding-inline: 8px;
  `,

  shareButton: css`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  doneButton: css`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
}
